import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Spinner.css';

const Spinner = ({ message, size = 'normal', overlay = false }) => {
  const { t } = useLanguage();
  const content = (
    <div className="spinner-container">
      <div className={`spinner${size === 'large' ? ' large' : ''}`}></div>
      <p style={size === 'large' ? { fontSize: '1.3em', marginTop: 24 } : {}}>
        {message || t('loading')}
      </p>
    </div>
  );
  return overlay ? <div className="spinner-overlay">{content}</div> : content;
};

export default Spinner; 